export default "__VITE_ASSET__BZUkGkYk__"